import commonStrings from "./common";
import dashboardStrings from "./pages/dashboardPage.strings";
import deviceSettingsStrings from "./pages/deviceSettings.strings";
import locationsStrings from "./pages/locationsPage.strings";
import usersStrings from "./pages/usersPage.strings";
import adminStrings from "./pages/adminPage.strings";
import deviceDetailModalStrings from "./components/deviceDetailModal.strings";

const strings = {
  ...commonStrings,
  ...dashboardStrings,
  ...deviceSettingsStrings,
  ...locationsStrings,
  ...usersStrings,
  ...adminStrings,
  ...deviceDetailModalStrings,
};

export default strings;
